export default __webpack_public_path__ + "static/media/ISEO CLASS 3 SYLLABUS.8108c179.pdf";